module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "x-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "4px",
      "width": "100%",
      "display": "flex",
      "left": "0px",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deviceToggle = 'desktop'
      }
    }
  }, [_vm._v("Desktop")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deviceToggle = 'mobile'
      }
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.deviceToggle = 'amp'
      }
    }
  }, [_vm._v("AMP")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "min-height": "calc(98vh - 115px)"
    }
  }, [_vm._t("body", [(_vm.deviceToggle == 'desktop') ? _c('iframe', {
    staticStyle: {
      "width": "1280px",
      "height": "calc(98vh - 115px)",
      "margin": "20px auto",
      "display": "block"
    },
    attrs: {
      "src": _vm.previewUrl + _vm.slug + '/' + _vm.password + '/'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deviceToggle == 'mobile') ? _c('iframe', {
    staticStyle: {
      "width": "400px",
      "height": "800px",
      "margin": "20px auto",
      "display": "block"
    },
    attrs: {
      "src": _vm.previewUrl + _vm.slug + '/' + _vm.password + '/'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deviceToggle == 'amp') ? _c('iframe', {
    staticStyle: {
      "width": "400px",
      "height": "800px",
      "margin": "20px auto",
      "display": "block"
    },
    attrs: {
      "src": _vm.previewUrl + _vm.slug + '/' + _vm.password + '/amp/'
    }
  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('span', {
    staticStyle: {
      "width": "700px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.copyText();
      }
    }
  }, [_vm._v("COPY")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "previewText"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ca5984"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/articlePreview.vue
// module id = 629
// module chunks = 1